// extracted by mini-css-extract-plugin
export default {"currentbody":"HomeStyle_currentbody__sToez","Title":"HomeStyle_Title__TaxPC","Author":"HomeStyle_Author__K5mNV"};